import { gql } from '@apollo/client';

const DATE_RECOMMENDATION_FRAGMENT = gql`
    fragment DateRecommendation on VisitishDateRecommendation {
        date
        dayOfWeek
        recommendationRank
        isSatisfactory
        isInFuture
        hasShifts
        wouldClinicianBeOverfullByVisitDuration
        doesRespectZeroDaySpacingWithinOrder
        doesRespectOneDaySpacingWithinOrder
        llmNotesParsingScore
        llmNotesParsingReason
        matchesExistingVisitAddress
        distanceFromClinicianScheduleCentroidMi
        distanceScore
        numIncompleteVisitsOnDateForBusiestClinician
    }
`;

export const VISIT_RECOMMENDED_DATES_FRAGMENT = gql`
    fragment VisitRecommendedDates on VisitDateRecommendations {
        visit {
            id
        }
        recommendedDates: recommendedDatesGivenOtherRecommendations {
            ...DateRecommendation
        }
    }
    ${DATE_RECOMMENDATION_FRAGMENT}
`;

export const VISIT_REQUEST_RECOMMENDED_DATES_FRAGMENT = gql`
    fragment VisitRequestRecommendedDates on VisitRequestDateRecommendations {
        visitRequest {
            id
        }
        recommendedDates: recommendedDatesGivenOtherRecommendations {
            ...DateRecommendation
        }
    }
    ${DATE_RECOMMENDATION_FRAGMENT}
`;
